import React from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useClientTypes } from './clientTypes/useClientTypes';
import { ClientTypeCard } from './clientTypes/ClientTypeCard';
import { ClientAssignmentsTable } from './clientTypes/ClientAssignmentsTable';
import { CreateClientTypeDialog } from './clientTypes/CreateClientTypeDialog';
import { EditClientTypeDialog } from './clientTypes/EditClientTypeDialog';
import { AssignClientTypeDialog } from './clientTypes/AssignClientTypeDialog';

const ClientTypes = () => {
  const ct = useClientTypes();

  if (ct.loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <RefreshCw className="h-8 w-8 animate-spin text-amber-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="client-types-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Client Types & Pricing</h1>
          <p className="text-sm text-gray-600 mt-1">
            Manage pricing tiers, discounts, and invoice workflows for different client types
          </p>
        </div>
        <Button
          onClick={() => ct.setShowCreateDialog(true)}
          className="bg-amber-500 hover:bg-amber-600"
          data-testid="add-client-type-btn"
        >
          <Plus className="h-4 w-4 mr-2" />
          Add Client Type
        </Button>
      </div>

      {/* Client Types Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {ct.clientTypes.map((type) => (
          <ClientTypeCard
            key={type.id}
            type={type}
            clients={ct.clients}
            onEdit={ct.setEditingType}
            onDelete={ct.handleDeleteType}
            onUpdateCategoryDiscount={ct.handleUpdateCategoryDiscount}
          />
        ))}
      </div>

      {/* Client Assignments Section */}
      <ClientAssignmentsTable
        clients={ct.clients}
        getClientTypeName={ct.getClientTypeName}
        onChangeType={ct.openAssign}
      />

      <CreateClientTypeDialog
        open={ct.showCreateDialog}
        onOpenChange={ct.setShowCreateDialog}
        newType={ct.newType}
        setNewType={ct.setNewType}
        onCreate={ct.handleCreateType}
      />

      <EditClientTypeDialog
        editingType={ct.editingType}
        setEditingType={ct.setEditingType}
        onSave={ct.handleUpdateType}
      />

      <AssignClientTypeDialog
        open={ct.showAssignDialog}
        onOpenChange={ct.setShowAssignDialog}
        clientTypes={ct.clientTypes}
        selectedClient={ct.selectedClient}
        onAssign={ct.handleAssignClientType}
      />
    </div>
  );
};

export default ClientTypes;
